<template>
  <main class="ws">

<!-- ============ 首屏 ============ -->
<section class="ph ph--ink ph--center">
  <div class="wrap">
    <span class="ph__kicker">{{ $t("跨境物流") }}</span>
    <h1 class="ph__title">{{ $t("从你手里到客户手里，") }}<br class="br-m">{{ $t("中间这一段我们接") }}</h1>
    <p class="ph__sub">{{ $t("头程揽收、报关出境、干线运输、末端派送——") }}<b>{{ $t("四条线路按货物和时效选") }}</b>{{ $t("。面单在后台打，轨迹在后台看，出事有人管。") }}</p>
    <div class="btns" style="justify-content:center">
      <router-link class="btn btn--primary" to="/sign-up">{{ $t("免费开店，先算一单运费") }}</router-link>
      <a class="btn btn--line" href="#lanes">{{ $t("看三条线路") }}</a>
    </div>
    <p class="ph__meta">
      <i><svg class="ico"><use href="#i-clock"/></svg>{{ $t("美线专线 6–9 天") }}</i>
      <i><svg class="ico"><use href="#i-globe"/></svg>{{ $t("220+ 国家可达") }}</i>
      <i><svg class="ico"><use href="#i-pin"/></svg>{{ $t("全程轨迹可查") }}</i>
    </p>


  </div>
</section>

<div class="guide-band guide-band--after-ink">
  <div class="wrap">
<div class="guide guide--center">
      <img class="guide__m" src="/website/img/tao-box.png" alt="">
      <div class="bubble">{{ $t("以前要加三个货代微信、问四次价格。") }}<b>{{ $t("现在一个后台里比价下单") }}</b>{{ $t("，单号自动回到订单里。") }}</div>
    </div>
  </div>
</div>

<!-- ============ 数据 ============ -->
<section class="sec sec--tight">
  <div class="wrap">
    <div class="metrics">
      <div class="metric"><b>6–9</b><span>{{ $t("美线专线参考时效（天）") }}</span></div>
      <div class="metric"><b>220<em>+</em></b><span>{{ $t("可送达国家与地区") }}</span></div>
      <div class="metric"><b>12</b><span>{{ $t("国内揽收仓，就近交货") }}</span></div>
      <div class="metric"><b>3</b><span>{{ $t("主力承运商实时比价") }}</span></div>
    </div>
    <p class="plans__note">{{ $t("以上为常见线路的参考区间，具体时效与价格以系统按重量、目的地、品类算出的报价为准。") }}</p>
  </div>
</section>

<!-- ============ 三条线路 ============ -->
<section class="sec sec--gray" id="lanes">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("三条线路") }}</span>
      <h2 class="sec__title">{{ $t("货不一样，走法也不一样") }}</h2>
      <p class="sec__sub">{{ $t("轻小件走小包，多件合一起走集运，卖得快的备到海外仓。三条路可以同时用。") }}</p>
    </div>

    <div class="grid3">
      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-box"/></svg></span>
        <h3 class="card__t">{{ $t("直发小包") }}</h3>
        <p class="card__d">{{ $t("一单一发，不用备货。适合刚起步、单量不大、品类还摸不准的时候。") }}</p>
        <ul class="card__list">
          <li>{{ $t("按克计费，200g 起") }}</li>
          <li>{{ $t("美国 6–9 天 / 欧洲 7–12 天") }}</li>
          <li>{{ $t("带全程跟踪号") }}</li>
        </ul>
        <p class="card__d" style="margin-top:14px;color:var(--p)">{{ $t("适合：单价 $10–60 的轻小件") }}</p>
      </article>

      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-layers"/></svg></span>
        <h3 class="card__t">{{ $t("集运合箱") }}</h3>
        <p class="card__d">{{ $t("同一个客户买了几件，先到国内仓，去掉外包装合成一箱再发。运费按一箱算，不是按四箱算。") }}</p>
        <ul class="card__list">
          <li>{{ $t("多件合并，省首重") }}</li>
          <li>{{ $t("免费仓储 30 天") }}</li>
          <li>{{ $t("可代贴标、代加固") }}</li>
        </ul>
        <p class="card__d" style="margin-top:14px;color:var(--p)">{{ $t("适合：多件订单、批发小单") }}</p>
      </article>

      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-warehouse"/></svg></span>
        <h3 class="card__t">{{ $t("海外仓备货") }}</h3>
        <p class="card__d">{{ $t("卖得动的款提前备到当地仓，客户下单当天就发。退换也能就地处理。") }}</p>
        <ul class="card__list">
          <li>{{ $t("本地派送 2–4 天") }}</li>
          <li>{{ $t("支持本地退换地址") }}</li>
          <li>{{ $t("库存和店铺同步") }}</li>
        </ul>
        <p class="card__d" style="margin-top:14px;color:var(--p)">{{ $t("适合：月销 100 单以上的爆款") }}</p>
      </article>
    </div>
  </div>
</section>

<!-- ============ 全链路 ============ -->
<section class="sec">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("全链路") }}</span>
      <h2 class="sec__title">{{ $t("一件包裹要过五道手") }}</h2>
      <p class="sec__sub">{{ $t("哪一段由谁负责，写清楚了，出问题才知道找谁。") }}</p>
    </div>

    <div class="flow">
      <div class="flow__node flow__node--you">
        <div class="flow__icon"><svg class="ico"><use href="#i-tag"/></svg></div>
        <em>{{ $t("你打包") }}</em>
        <p>{{ $t("后台打面单") }}<br>{{ $t("贴好交给快递") }}</p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node">
        <div class="flow__icon"><svg class="ico"><use href="#i-warehouse"/></svg></div>
        <em>{{ $t("国内仓") }}</em>
        <p>{{ $t("收货、验货") }}<br>{{ $t("合箱、称重") }}</p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node">
        <div class="flow__icon"><svg class="ico"><use href="#i-customs"/></svg></div>
        <em>{{ $t("报关出境") }}</em>
        <p>{{ $t("资料代填") }}<br>{{ $t("清单预申报") }}</p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node flow__node--us">
        <div class="flow__icon"><svg class="ico"><use href="#i-plane"/></svg></div>
        <em>{{ $t("干线") }}</em>
        <p>{{ $t("空运为主") }}<br>{{ $t("按线路排舱") }}</p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node flow__node--us">
        <div class="flow__icon"><svg class="ico"><use href="#i-truck"/></svg></div>
        <em>{{ $t("末端派送") }}</em>
        <p>{{ $t("当地邮政或快递") }}<br>{{ $t("签收信息回传") }}</p>
      </div>
    </div>

    <div class="flow__legend" style="margin-top:30px">
      <i>{{ $t("紫色：平台负责") }}</i>
      <i class="is-grey">{{ $t("灰色：你负责") }}</i>
    </div>
  </div>
</section>

<!-- ============ 时效价格 ============ -->
<section class="sec sec--gray">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("报价参考") }}</span>
      <h2 class="sec__title">{{ $t("什么货、走哪条、多少钱") }}</h2>
      <p class="sec__sub">{{ $t("下表按 200g 包裹估算，方便你先算一笔账。") }}</p>
    </div>

    <div class="tbl-wrap">
      <table class="tbl">
        <thead>
          <tr>
            <th>{{ $t("目的地") }}</th><th>{{ $t("线路") }}</th><th>{{ $t("参考时效") }}</th><th style="text-align:right">{{ $t("200g 参考运费") }}</th><th style="text-align:right">{{ $t("可跟踪") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>{{ $t("美国") }}</td><td>{{ $t("经济小包") }}</td><td>{{ $t("8–12 个工作日") }}</td><td class="num">{{ $t("¥26 起") }}</td><td class="num">{{ $t("全程") }}</td></tr>
          <tr><td>{{ $t("美国") }}</td><td>{{ $t("标准专线") }}</td><td>{{ $t("6–9 个工作日") }}</td><td class="num">{{ $t("¥34 起") }}</td><td class="num">{{ $t("全程") }}</td></tr>
          <tr><td>{{ $t("英国 / 德国") }}</td><td>{{ $t("欧洲专线") }}</td><td>{{ $t("7–12 个工作日") }}</td><td class="num">{{ $t("¥31 起") }}</td><td class="num">{{ $t("全程") }}</td></tr>
          <tr><td>{{ $t("日本 / 韩国") }}</td><td>{{ $t("东亚专线") }}</td><td>{{ $t("3–5 个工作日") }}</td><td class="num">{{ $t("¥22 起") }}</td><td class="num">{{ $t("全程") }}</td></tr>
          <tr><td>{{ $t("澳大利亚") }}</td><td>{{ $t("澳洲专线") }}</td><td>{{ $t("7–10 个工作日") }}</td><td class="num">{{ $t("¥30 起") }}</td><td class="num">{{ $t("全程") }}</td></tr>
          <tr><td>{{ $t("中东 / 南美") }}</td><td>{{ $t("偏远专线") }}</td><td>{{ $t("12–20 个工作日") }}</td><td class="num">{{ $t("¥45 起") }}</td><td class="num">{{ $t("仅关键节点") }}</td></tr>
        </tbody>
      </table>
    </div>
    <p class="cmp__note">{{ $t("表内为示意价格，不含燃油与偏远附加费。实际下单时系统按重量、体积重、品类实时报价。") }}</p>
  </div>
</section>

<!-- ============ 轨迹与异常 ============ -->
<section class="sec">
  <div class="wrap">
    <div class="frow">
      <div>
        <span class="frow__tag">{{ $t("轨迹") }}</span>
        <h2 class="frow__t">{{ $t("客户问「我的包裹到哪了」，你不用去翻聊天记录") }}</h2>
        <p class="frow__d">{{ $t("每单都有时间轴，从揽收到签收一条线拉下来。客户在你店里就能自己查，不用来问你。真出问题，系统会比客户先告诉你。") }}</p>
        <ul class="frow__list">
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("轨迹节点自动回传，中英文对照") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("超时未更新、清关滞留、派送失败会自动标红") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("异常件单独一列，处理完再归位") }}</span></li>
        </ul>
      </div>
      <div class="frow__media">
        <div class="media-card">
          <div class="tl">
            <div class="tl__i on">
              <div class="tl__t">{{ $t("已签收") }}</div>
              <div class="tl__d">{{ $t("Berlin, DE · 由收件人本人签收") }}</div>
              <div class="tl__time">10-28 14:26</div>
            </div>
            <div class="tl__i on">
              <div class="tl__t">{{ $t("派送中") }}</div>
              <div class="tl__d">{{ $t("Out for delivery · DHL 本地派送") }}</div>
              <div class="tl__time">10-28 08:02</div>
            </div>
            <div class="tl__i on">
              <div class="tl__t">{{ $t("清关完成") }}</div>
              <div class="tl__d">{{ $t("法兰克福口岸放行") }}</div>
              <div class="tl__time">10-27 21:40</div>
            </div>
            <div class="tl__i">
              <div class="tl__t">{{ $t("干线运输中") }}</div>
              <div class="tl__d">{{ $t("深圳 → 法兰克福，航班已起飞") }}</div>
              <div class="tl__time">10-25 03:12</div>
            </div>
            <div class="tl__i">
              <div class="tl__t">{{ $t("已入库合箱") }}</div>
              <div class="tl__d">{{ $t("深圳仓 · 2 件合并，减重 0.3kg") }}</div>
              <div class="tl__time">10-24 17:05</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ 退换与赔付 ============ -->
<section class="sec sec--gray">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("出问题怎么办") }}</span>
      <h2 class="sec__title">{{ $t("丢件、破损、退回来，都有说法") }}</h2>
      <p class="sec__sub">{{ $t("跨境最怕的不是出事，是出了事没人认。") }}</p>
    </div>

    <div class="grid3">
      <article class="card">
        <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-shield"/></svg></span>
        <h3 class="card__t">{{ $t("丢件赔付") }}</h3>
        <p class="card__d">{{ $t("承运商确认丢失后按申报价值赔付，上限写在报价单里，不用来回扯。") }}</p>
      </article>
      <article class="card">
        <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-refresh"/></svg></span>
        <h3 class="card__t">{{ $t("退换地址") }}</h3>
        <p class="card__d">{{ $t("美国、德国、英国有本地退货地址，客户寄回不用付国际邮费。") }}</p>
      </article>
      <article class="card">
        <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-life"/></svg></span>
        <h3 class="card__t">{{ $t("专人跟进") }}</h3>
        <p class="card__d">{{ $t("单票超过 15 天没更新，平台会主动开一张工单跟进，不用你催。") }}</p>
      </article>
    </div>
  </div>
</section>

<!-- ============ CTA ============ -->

<section class="sec sec--tight">
  <div class="wrap">
    <div class="pandy">
      <img class="pandy__m" src="/website/img/tao-box.png" alt="">
      <div>
        <p class="pandy__t">{{ $t("时效表里的数字是常态，不是承诺") }}</p>
        <p class="pandy__b">{{ $t("真卡住了，") }}<b>{{ $t("先看轨迹再问人") }}</b>{{ $t("。九成问题看单号就能定位：清关延误、地址不详、派送失败，轨迹上写得比客服说的清楚。") }}</p>

      </div>
    </div>
  </div>
</section>

<section class="sec sec--tight">
  <div class="wrap">
    <div class="cta">
      <div>
        <h2 class="cta__t">{{ $t("先算一单，再决定走哪条线") }}</h2>
        <p class="cta__d">{{ $t("开店后输入重量和目的地，三条线路的价格和时效会一起列出来。") }}</p>
      </div>
      <div class="cta__btns">
        <router-link class="btn btn--primary" to="/sign-up">{{ $t("免费开店试算") }}</router-link>
        <router-link class="btn btn--ghost" to="/payment">{{ $t("看收款怎么走") }}</router-link>
      </div>
    </div>
  </div>
</section>

</main>
</template>

<script>
export default {
  name: 'WebsiteLogistics',
}
</script>
